import Swiper from 'swiper';
import { EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';

// Row Blocks Slider using Swiper with fade, synced content/image
document.addEventListener('DOMContentLoaded', () => {
    const roots = document.querySelectorAll('.js-rowBlocksSlider');

    roots.forEach((root) => {
        const navItems = root.querySelectorAll('.o-rowBlocksSlider__navigation li');
        const contentBlock = root.querySelector('.o-rowBlocksSlider__block.-block2 .swiper');
        const imageBlock = root.querySelector('.o-rowBlocksSlider__block.-block3 .swiper');
        if (!navItems.length || !contentBlock || !imageBlock) return;

        // Determine initial index from nav
        const initialIndex = Math.max(0, Array.from(navItems).findIndex(li => li.classList.contains('-active')));

        // Init swipers
        const contentSwiper = new Swiper(contentBlock, {
            modules: [EffectFade],
            effect: 'fade',
            fadeEffect: { crossFade: true },
            speed: 500,
            allowTouchMove: false,
            autoHeight: false,
            initialSlide: initialIndex
        });

        const imageSwiper = new Swiper(imageBlock, {
            modules: [EffectFade],
            effect: 'fade',
            fadeEffect: { crossFade: true },
            speed: 500,
            allowTouchMove: false,
            initialSlide: initialIndex
        });

        // Sync on slide change
        contentSwiper.on('slideChange', () => {
            const idx = contentSwiper.activeIndex;
            if (imageSwiper.activeIndex !== idx) imageSwiper.slideTo(idx);
            // update nav active
            navItems.forEach((li, i) => li.classList.toggle('-active', i === idx));
        });

        // Nav click -> both sliders
        navItems.forEach((li) => {
            li.addEventListener('click', () => {
                const i = parseInt(li.getAttribute('data-trigger-index'), 10);
                if (Number.isFinite(i)) {
                    contentSwiper.slideTo(i);
                    imageSwiper.slideTo(i);
                }
            });
        });
    });
});